import request from '@/utils/request'
import { UserInfo } from '@/types/manage/userManage'

/**
 * 添加用户
 */
export const addTenantUser = (params: UserInfo) => {
  return request({
    url: '/blackcat/user/save',
    method: 'post',
    data: params
  })
}
/**
 * 编辑用户
 */
export const updateTenantUser = (params: UserInfo) => {
  return request({
    url: '/blackcat/user/update',
    method: 'post',
    data: params
  })
}
/**
 * 获取所有用户分页数据
 */
export const getTableUsers = (params: any) => {
  return request({
    url: '/blackcat/user/findall',
    method: 'get',
    params
  })
}
/**
 * 获取角色列表select
 */
export const getAllRoles = (params: any) => {
  return request({
    url: '/blackcat/role/list',
    method: 'get',
    params
  })
}
/**
 * 获取空余激活码的许可证列表CheckBox
 */
export const getAllActivation = (params: any) => {
  return request({
    url: '/blackcat/activation/code/available',
    method: 'get',
    params
  })
}
/**
 * 打开用户详情编辑页
 */
export const viewUserDetail = (params: any) => {
  return request({
    url: '/blackcat/user/detail',
    method: 'get',
    params
  })
}
/**
 * 用户管理中的许可证列表
 */
export const getActivationUserPage = (params: any) => {
  return request({
    url: '/blackcat/activation/user/page',
    method: 'get',
    params
  })
}
/**
 * 用户管理中的许可证列表
 */
export const changeUserFlag = (params: any) => {
  return request({
    url: '/blackcat/user/changeflag',
    method: 'post',
    data: params
  })
}
